import { register } from "@shopify/theme-sections";
import Swiper from "swiper/bundle";

register("hero-2", {
  initSlider() {
    const heroCarousel = this.container.querySelector(".hero-2__carousel");
    if (!heroCarousel) return;
    const heroswiper = new Swiper(heroCarousel, {
      loop: true,
      slidesPerView: 1,
      autoplay: false,
      pagination: {
        el: ".hero-swiper-pagination",
        type: "bullets",
      },
      breakpoints: {
        769: {
          slidesPerView: 2,
          pagination: false,
          allowTouchMove: false,
        },
      },
    });
  },

  onLoad: function (e) {
    this.initSlider();
  },
});
